/* Copyright (c) 2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { noop } from "~/tools";
import { FiltersProp } from "../types";
import { EstateDateRangeFilter } from "./EstateDateRangeFilter";
import { EstateFilterHeader } from "./EstateFilterHeader";

type Props = {
  filters: FiltersProp;
  updateFilters: (input: FiltersProp) => void;
};

export function DiscoveryTimeFilter({ filters, updateFilters }: Props) {
  const { firstSeenAtFrom = "", firstSeenAtTo = "" } = filters;

  return (
    <>
      <EstateFilterHeader onSetSearch={noop} />
      <EstateDateRangeFilter
        description="The time range when the resource was discovered"
        dateFrom={firstSeenAtFrom}
        dateTo={firstSeenAtTo}
        onDateFromChange={(value) =>
          updateFilters({
            firstSeenAtFrom: value,
          })
        }
        onDateToChange={(value) =>
          updateFilters({
            firstSeenAtTo: value,
          })
        }
      />
    </>
  );
}
